"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var readImage_1 = __importDefault(require("../utils/readImage"));
var ImagePreview = /** @class */ (function (_super) {
    __extends(ImagePreview, _super);
    function ImagePreview() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.componentIsMounted = false;
        _this.containerRef = react_1.default.createRef();
        _this.state = { src: null, styles: {} };
        return _this;
    }
    ImagePreview.prototype.componentDidMount = function () {
        this.componentIsMounted = true;
        var preview = this.props.preview;
        if (preview) {
            this.enqueueLoad();
        }
    };
    ImagePreview.prototype.componentDidUpdate = function (prevProps) {
        var preview = this.props.preview;
        if (preview && (preview !== prevProps.preview)) {
            this.enqueueLoad();
        }
    };
    ImagePreview.prototype.componentWillUnmount = function () {
        this.componentIsMounted = false;
    };
    ImagePreview.prototype.enqueueLoad = function () {
        var _this = this;
        var _a = this.props, image = _a.image, imageAsBackground = _a.imageAsBackground, preview = _a.preview;
        var container = this.containerRef.current;
        if (container && container.parentNode instanceof HTMLElement) {
            var _b = container.parentNode, clientWidth = _b.clientWidth, clientHeight = _b.clientHeight;
            readImage_1.default(image, preview, clientWidth, clientHeight).then(function (_a) {
                var src = _a.src, styles = _a.styles;
                if (_this.componentIsMounted) {
                    if (imageAsBackground) {
                        _this.setState({ src: src, styles: __assign(__assign({}, styles), { width: "auto", height: "auto", margin: "0 auto", maxWidth: "100%", maxHeight: "100%" }) });
                    }
                    else {
                        _this.setState({ src: src, styles: styles });
                    }
                }
            }).catch(function (_error) {
                _this.setState({
                    src: "https://images.unsplash.com/photo-1605827170202-169d05c841d5?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1490&q=80",
                    styles: { width: "auto", height: "auto", margin: "0 auto", maxWidth: "100%", maxHeight: "100%" }
                });
            });
        }
    };
    ImagePreview.prototype.render = function () {
        var _a = this.state, src = _a.src, styles = _a.styles;
        var _b = this.props, editorOpen = _b.editorOpen, imageAsBackground = _b.imageAsBackground;
        return (react_1.default.createElement("span", { ref: this.containerRef, style: imageAsBackground ? { alignItems: "center", display: "flex", justifyContent: "center" } : {} }, src && !editorOpen && react_1.default.createElement("img", { className: "chq-ipv", src: src || undefined, alt: "Preview", style: styles })));
    };
    return ImagePreview;
}(react_1.default.Component));
exports.default = ImagePreview;
